<template>
  <div class="mt-2">
    <span
      v-if="themeLight"
      class="fas fa-moon"
      :class="themeLight ? 'animate__animated animate__wobble' : ''"
      style="font-size: 18px; cursor: pointer"
      @click="
        themeLight = false
        Moon()
      "
    ></span>
    <span
      v-else
      class="fas fa-sun"
      :class="themeLight ? 'animate__animated animate__wobble' : ''"
      style="font-size: 18px; cursor: pointer"
      @click="
        themeLight = true
        Sun()
      "
    ></span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      themeLight: false,
    }
  },
  methods: {
    Sun() {
      var r = document.querySelector('.root')
      r.style.setProperty('--sidebar-bg-color', '#fff')
      r.style.setProperty('--sidebar-color-item', '#4B525E')
      r.style.setProperty('--sidebar-action-bg', '#f2f8fa')
      r.style.setProperty('--navbar-bg', '#f2f8fa')
      r.style.setProperty('$navbar-link-color', '#f2f8fa')
      r.style.setProperty('--table-background', '#f8f9fa')
      r.style.setProperty('--table-border-color', '#EAF0F6')
      r.style.setProperty('--hr-color', '#eae5e5')
      r.style.setProperty('--btn-bg-success', '#4caf50')
      r.style.setProperty('--btn-bg-warning', '#d84315')
      r.style.setProperty('--btn-color-success', '#fff')
      r.style.setProperty('--btn-color-warning', '#fff')

      this.SetLoaclStorage('true')
    },
    Moon() {
      var r = document.querySelector('.root')
      r.style.setProperty('--sidebar-bg-color', '#222831')
      r.style.setProperty('--sidebar-color-item', '#fff')
      r.style.setProperty('--sidebar-action-bg', '#29323a')
      r.style.setProperty('--navbar-bg', '#1d252b')
      r.style.setProperty('--table-background', '#29323a')
      r.style.setProperty('--table-border-color', '#3c484f')
      r.style.setProperty('--hr-color', '#29323a')
      r.style.setProperty('--btn-bg', '#222831')
      r.style.setProperty('--btn-bg-success', '#222831')
      r.style.setProperty('--btn-bg-warning', '#222831')
      r.style.setProperty('--btn-color-success', '#4caf50')
      r.style.setProperty('--btn-color-warning', '#d84315')

      this.SetLoaclStorage('false')
    },
    SetLoaclStorage(state) {
      this.$cookies.set('themeLight', state)
      this.$store.state.ThemeLight = this.$cookies.get('themeLight')
      // console.log(this.$store.state.ThemeLight)
    },
  },
  mounted() {
    this.$store.state.ThemeLight = this.$cookies.get('themeLight')
    this.themeLight = JSON.parse(this.$cookies.get('themeLight'))
    if (this.$cookies.get('themeLight') === 'true') {
      this.Sun()
    } else {
      this.Moon()
    }
  },
}
</script>
<style src="./Helper.scss" lang="scss"></style>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
.sidebar .sidebarStatic {
  overflow: scroll !important;
  height: 100% !important;
}

/* .modal-content  .bg-dark{
  background: var(--sidebar-action-bg) !important;;
  color: var(--sidebar-color-item) !important;
} */
/* .modal-dialog */
#modal-scopedAlignColumns___BV_modal_content_ {
  color: #f3f3f3 !important;
}
.input-group-text.text-success {
  background: var(--sidebar-bg-color) !important;
}
.list-group-item:hover {
  transition: 0.1s !important;
  background: var(--sidebar-action-bg) !important;
  color: var(--sidebar-color-item) !important;
}
.list-group-item {
  color: var(--sidebar-color-item) !important;
}
.notificationsWrapper .list-group-item .btn-success {
  background: var(--btn-bg-success) !important;
  color: var(--btn-color-success) !important;
}
.notificationsWrapper .list-group-item .btn-danger {
  background: var(--btn-bg-warning) !important;
  color: var(--btn-color-warning) !important;
}

/*
 .my-second-class > .modal-dialog > .modal-content > .modal-header {
  background: var(--sidebar-action-bg) !important;;
  color: var(--sidebar-color-item) !important;
} */
#Card .tab-pane.active,
.content .nav-item a {
  background: var(--sidebar-action-bg) !important;
  border: var(--sidebar-action-bg) !important;
  box-shadow: none !important;
}
.vue-treeselect__option :hover,
.vue-treeselect__option--selected,
.vue-treeselect__option-arrow-container:hover,
.vue-treeselect__option--highlight {
  background: var(--sidebar-bg-color) !important;
}

#Card .tab-pane.active small,
span,
p,
a,
h6 {
  color: var(--sidebar-color-item) !important;
}
hr {
  border-top: 1px solid var(--hr-color) !important;
}
#Card input,
.vue-treeselect__control,
.vue-treeselect__menu,
.form-control {
  background: var(--sidebar-action-bg) !important;
  color: var(--sidebar-color-item) !important;
}
.dropdown-menu {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item) !important;
}
.dropdown-menu li:hover a {
  background: var(--sidebar-action-bg) !important;
  /* background: #ff0000 !important; */
  color: var(--logo-color) !important;
}
.alert-secondary {
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
}
.xl-checkbox {
  transform: scale(2);
  margin-right: 11px;
  margin-top: 40%;
}
small {
  color: var(--sidebar-color-item) !important;
}
.text-logo {
  color: var(--logo-color) !important;
}

.item {
  margin: auto;
}

/* checkbox-rect */
.checkbox-rect input[type='checkbox'] {
  display: none;
}
.checkbox-rect input[type='checkbox'] + label {
  display: block;
  position: relative;
  /* padding-left: 35px; */
  margin-bottom: 20px;
  font: 14px/20px 'Open Sans', Arial, sans-serif;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.checkbox-rect input[type='checkbox']:hover + label:hover {
  color: rgb(23, 86, 228);
}
.checkbox-rect input[type='checkbox']:hover + label:before {
  background: var(--sidebar-bg-color);
  box-shadow: inset 0px 0px 0px 2px #f7f2f2;
}
.checkbox-rect input[type='checkbox'] + label:last-child {
  margin-bottom: 0;
}
.checkbox-rect input[type='checkbox'] + label:before {
  content: '';
  display: block;
  width: 1.4em;
  height: 1.4em;
  border: 1px solid #343a3f;
  border-radius: 0.2em;
  position: absolute;
  left: 0;
  top: 0;
  -webkit-transition: all 0.2s, background 0.2s ease-in-out;
  transition: all 0.2s, background 0.2s ease-in-out;
  background: #f3f3f3;
}
.checkbox-rect input[type='checkbox']:checked + label:before {
  width: 1.3em;
  height: 1.3em;
  border-radius: 0.2em;
  border: 2px solid #fff;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  background: var(--logo-color);
  box-shadow: 0 0 0 1px #000;
}
/* checkbox-rect end */

.btn-light {
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
  border: 1px solid var(--sidebar-color-item);
}
.btn-light:hover {
  color: var(--sidebar-bg-color) !important;
  background: var(--sidebar-color-item);
  /* color:#222831 !important; */
}
.btn-light:active {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item) !important;
  border: 1px solid var(--sidebar-color-item) !important;
}

.btn-success {
  background: var(--btn-bg-success);
  color: var(--btn-color-success);
  border: 1px solid var(--btn-color-success);
}
.btn-success:hover {
  color: var(--btn-bg-success) !important;
  background: var(--btn-color-success);
  /* color:#222831 !important; */
}
.btn-success:active {
  background: var(--btn-bg-success) !important;
  color: var(--btn-color-success) !important;
  border: 1px solid var(--btn-color-success) !important;
}

.btn-warning {
  background: var(--btn-bg-warning);
  color: var(--btn-color-warning);
  border: 1px solid var(--btn-color-warning);
}
.btn-warning:hover {
  color: var(--btn-bg-warning) !important;
  background: var(--btn-color-warning) !important;
  border: 1px solid var(--btn-bg-warning);
  /* color:#222831 !important; */
}
.btn-warning:active {
  background: var(--btn-color-warning) !important;
  color: var(--btn-bg-warning) !important;
  /* color:#222831 !important; */
}
.vpd-time {
  background: var(--sidebar-bg-color) !important;
}
.dirltr {
  direction: ltr;
}
/* .vpd-actions button:not(:disabled), [type="button"]:not(:disabled){
   color:var(--sidebar-color-item) !important;
}
.vpd-actions:hover button:not(:disabled), [type="button"]:not(:disabled){
   background:none !important;
} */
.apexcharts-legend-text {
  font-family: 'IRANSansWeb' !important;
}
.apexcharts-text.apexcharts-pie-label {
  font-family: 'IRANSansWeb' !important;
}
.apexcharts-legend.apexcharts-align-center.apx-legend-position-right {
  text-align: right !important;
  text-shadow: none !important;
}
.apexcharts-text.apexcharts-pie-label {
  font-weight: normal !important;
  text-shadow: none !important;
}
.apexcharts-canvas text tspan {
  font-family: 'IRANSansWeb' !important;
  fill: var(--sidebar-color-item) !important;
  color: var(--sidebar-color-item) !important;
}
.apexcharts-tooltip-text .apexcharts-tooltip-title .apexcharts-tooltip-text-y-label .apexcharts-tooltip-text-y-value {
  font-family: 'IRANSansWeb' !important;
  color: var(--sidebar-color-item) !important;
  fill: var(--sidebar-color-item) !important;
  background: var(--sidebar-action-bg) !important;
}
.apexcharts-legend-marker {
  margin-right: 3px !important;
  margin-left: 3px !important;
}
.swal2-popup {
  direction: rtl !important;
}
</style>
